// @ts-nocheck

import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from 'antd/lib/button';
import { Link } from '../../lib/routerAdapter';
import { navigate } from '../../lib/routerAdapter';


import { Table } from '../../components/ui';
import { Header, Section } from '../../components/layout';







import { fuelGroups, accessTypeEnum } from '../../lib/enum';
import { fuelCardApi } from '../../lib/api';
import { getListInitialState, setQueryParams } from '../../lib/helpers';
import Filter from './Filter';
import { withUserAccess } from './../withUserAccess';

const canAddAccess = [accessTypeEnum.admin, accessTypeEnum.handlingEquipment];












export const COLUMNS = [
{
  title: '№',
  dataIndex: 'id',
  sorter: true,
  width: 20
},
{
  title: 'ТС',
  dataIndex: 'vehicle',
  width: 200,
  breakByWidth: true,
  render: (vehicle, record) => {
    const { modelName, brandName, licensePlate } = record;
    return [brandName, modelName, licensePlate && `(${licensePlate})`].
    join(' ').
    trim();
  }
},
{
  title: 'Номер карты',
  dataIndex: 'cardNumber',
  sorter: true
},
{
  title: 'Вид топлива',
  dataIndex: 'fuelGroup',
  sorter: true,
  render: (group) => fuelGroups[group]
}];


export class FuelCardsList extends Component {
  static defaultProps = {
    location: {}
  };

  getDefaultFilter = () => {
    const canViewAll = this.props.userAccess.some((access) =>
    [accessTypeEnum.viewingAllEquipments].includes(access)
    );
    const defaultFilter = canViewAll ?
    {} :
    {
      nodeId: this.props.employeeBranchOrgUnitId,
      nodeFilterType: 'branchAndChildren'
    };
    return defaultFilter;
  };

  state = {
    ...getListInitialState(),
    filter: this.getDefaultFilter()
  };

  columns = [...COLUMNS];

  fetchFuelCards = async (
  page = 1,
  params = {}) =>
  {
    try {
      const { filter } = this.state;
      this.setState({ loading: true });
      const { data, totalCount } = await fuelCardApi.fetchFuelCards({
        ...filter,
        page,
        ...params,
        ...this.getDefaultFilter() // фильтр по оргюнитам в зависимости от клэймов
      });
      setQueryParams({ page });
      this.setState({ loading: false, data, totalCount, page });
    } catch (err) {
    } finally {
      this.setState({ loading: false });
    }
  };

  handleRowClick = async (id) => navigate(`/admin/fuel-cards/${id}`);

  cleanFilter = () => this.setState({ filter: { ...null } }, this.fetchFuelCards);

  applyFilter = (filter) =>
  this.setState({ filter }, this.fetchFuelCards);

  render() {
    const { location, userAccess } = this.props;

    const { data, totalCount, page, pageSize, loading, filter } = this.state;
    const canAdd = userAccess.some((access) => canAddAccess.includes(access));
    return (
      <>
        <Header
          left={<h1>Топливные карты</h1>}
          right={
          canAdd &&
          <Link to="/admin/fuel-cards/new">
                <Button type="primary">Создать</Button>
              </Link>

          } />

        <Section>
          <Filter
            filter={filter}
            applyFilter={this.applyFilter}
            cleanFilter={this.cleanFilter} />

          <Table
            onRow={(record) => ({
              onClick: () => this.handleRowClick(record.id)
            })}
            loading={loading}
            data={data}
            columns={this.columns}
            fetch={this.fetchFuelCards}
            fetchOnMount
            rowKey="id"
            pagination={{
              location,
              page,
              pageSize,
              totalCount
            }} />

        </Section>
      </>);

  }
}

export default connect((state) => ({
  employeeBranchOrgUnitId: state.auth.profile.employeeBranchOrgUnitId
}))(withUserAccess(FuelCardsList));
